import React, { useState } from "react";
import { trackEvent } from "../utils/analytics";
import "./playerEntryAvatarSelect.scss";

const AVATARS = [
  { id: "es_avatar_one", src: "./img/es-avatar-burger-dance.jpg", alt: "Avatar 1" },
  { id: "es_avatar_two", src: "./img/es-avatar-disco-ball.jpg", alt: "Avatar 2" },
  { id: "es_avatar_three", src: "./img/es-avatar-marg-red.jpg", alt: "Avatar 3" },
  { id: "es_avatar_four", src: "./img/es-avatar-margs-cream.jpg", alt: "Avatar 4" },
  { id: "es_avatar_five", src: "./img/es-avatar-pizza-apricot.jpg", alt: "Avatar 5" },
  { id: "es_avatar_six", src: "./img/es-avatar-puck-red.jpg", alt: "Avatar 6" },
  { id: "es_avatar_seven", src: "./img/es-avatar-sun-orange.jpg", alt: "Avatar 7" },
  { id: "es_avatar_eight", src: "./img/es-avatar-tex-boot.jpg", alt: "Avatar 8" },
];

export interface PlayerAvatarSelectProps {
  onAvatarChosen: (avatarSrc: string) => void;
  onBack: () => void;
}

const PAGE_SIZE = 4;
const TOTAL_PAGES = Math.ceil(AVATARS.length / PAGE_SIZE);

export const PlayerAvatarSelect: React.FC<PlayerAvatarSelectProps> = ({ onAvatarChosen, onBack }) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [page, setPage] = useState<number>(0);

  const handleConfirm = () => {
    if (selectedIndex !== null) {
      trackEvent({ gaEvent: "avatar_selected" });
      onAvatarChosen(AVATARS[selectedIndex].src);
    }
  };

  const handlePrev = () => {
    if (selectedIndex !== null) {
      // in large view: cycle individual avatars
      setSelectedIndex((prev) => (prev! - 1 + AVATARS.length) % AVATARS.length);
    } else {
      // in grid view: go to previous page
      setPage((p) => (p - 1 + TOTAL_PAGES) % TOTAL_PAGES);
    }
  };

  const handleNext = () => {
    if (selectedIndex !== null) {
      // in large view: cycle individual avatars
      setSelectedIndex((prev) => (prev! + 1) % AVATARS.length);
    } else {
      // in grid view: go to next page
      setPage((p) => (p + 1) % TOTAL_PAGES);
    }
  };

  const pageAvatars = AVATARS.slice(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE);

  return (
    <div className="pageContainer">
      <div className="logoContainer">
        <img src={"./img/es-logo.svg"} width="110px" alt="Electric Shuffle" />
      </div>
      <div className="contentCard-outer">
        <div className="contentCard">
          <div className="formContainer">
            <div className="formHeader">
              <div className="step">Step 2/3</div>
              <div className="title">Your avatar</div>
            </div>
            <div className="avatarCarousel">
              <button className="avatarNav avatarNav--prev" onClick={handlePrev} aria-label="Previous avatar">
                <img src="./img/nav-arrow-back.svg" alt="" />
              </button>

              {selectedIndex === null ? (
                <div className="avatarGrid">
                  {pageAvatars.map((avatar, pageIndex) => {
                    const globalIndex = page * PAGE_SIZE + pageIndex;
                    return (
                      <button
                        key={avatar.id}
                        className="avatarOption"
                        onClick={() => setSelectedIndex(globalIndex)}
                        aria-label={avatar.alt}
                      >
                        <img src={avatar.src} alt={avatar.alt} />
                      </button>
                    );
                  })}
                </div>
              ) : (
                <div
                  className="avatarOption avatarOption--selected avatarOption--large"
                  onClick={() => setSelectedIndex(null)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === "Enter" && setSelectedIndex(null)}
                  aria-label={AVATARS[selectedIndex].alt}
                >
                  <img src={AVATARS[selectedIndex].src} alt={AVATARS[selectedIndex].alt} />
                </div>
              )}

              <button className="avatarNav avatarNav--next" onClick={handleNext} aria-label="Next avatar">
                <img src="./img/nav-arrow-forward.svg" alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <footer className="btn-container">
        <button className="small secondary" onClick={onBack}>
          BACK
        </button>
        <button className="small" onClick={handleConfirm} disabled={selectedIndex === null}>
          CONFIRM
        </button>
      </footer>
    </div>
  );
};
